import { LatLng } from "leaflet";
import { useState } from "react";
import { Polyline, Popup, useMap, useMapEvent } from "react-leaflet";
import { Card } from "./card";
import DirectionOverlay from "./directional-markers";
import { LineColors } from "./line-colors";
import { IDetour } from "./map";

export interface ILine {
  id: string;
  refinedGeometry: {
    type: string;
    coordinates: number[][];
  };
  type: string;
  directionalImpact: number;
  detourId: string;
  geometry: {
    type: string;
    coordinates: number[][];
  };
}

export default function DetourLines({
  lines,
  detours,
  visibleAtZoomLevel = null,
  hidePopup = false,
}: {
  lines: ILine[];
  detours: IDetour[] | [];
  visibleAtZoomLevel?: null | number | "any";
  hidePopup?: boolean;
}) {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());

  useMapEvent("zoomend", () => setZoom(map.getZoom()));

  return (
    visibleAtZoomLevel &&
    (visibleAtZoomLevel === "any" || zoom >= visibleAtZoomLevel) && (
      <>
        <DirectionOverlay data={lines} />
        {lines
          ?.filter((line) => ["LineString", "MultiLineString"].includes(line.geometry.type))
          .map((line) => {
            const detour = detours.find((detour) => detour.id === line.detourId);

            // @ts-ignore | new line will be automatically supported without change needed
            const color = LineColors[line.type] ?? LineColors.default;
            return (
              <Polyline
                pathOptions={{
                  weight: zoom === 15 ? 5 : 6,
                  color,
                }}
                key={line.id}
                positions={line.geometry.coordinates.map((coor) => new LatLng(coor[1], coor[0]))}
              >
                {detour && !hidePopup && (
                  <Popup>
                    <Card item={detour} />
                  </Popup>
                )}
              </Polyline>
            );
          })}
      </>
    )
  );
}
